<form [ngClass]="{ 'modal-padding': modalPadding }" [formGroup]="loginForm" (ngSubmit)="onSubmit()" (keydown)="onKeyDown($event)" class="row justify-content-center mt-5">
  <div [ngClass]="{ 'col-lg-4': !modalPadding }" class="col-12 col-md-6">
    <app-input [form]="loginForm" formGroupName="email" placeHolder="E-mail"></app-input>
  </div>
  <div class="d-100"></div>
  <div [ngClass]="{ 'col-lg-4': !modalPadding }" class="col-12 col-md-6">
    <app-input inputType="password" [form]="loginForm" formGroupName="password" placeHolder="Password"></app-input>
    <div class="text-end">
      <a class="forgot-password-link" [routerLink]="['/authentication', 'forgot-password']">Forgot password?</a>
    </div>
  </div>
  <div class="d-100"></div>
  <div class="col-auto">
    <app-checkbox [form]="loginForm" formGroupName="rememberMe" label="Remember me"></app-checkbox>
  </div>
  <div class="d-100"></div>
  <div [ngClass]="{ 'col-lg-4': !modalPadding }" class="col-12 col-md-6 mt-2">
    <button class="btn btn-primary w-100" type="submit">
      Log in
    </button>
  </div>
</form>
